module.exports = {
      id: "menu_burger-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#menu_burger-usage",
      toString: function () {
        return this.url;
      }
    }